module.exports = __webpack_public_path__ + "static/media/development.df4ca07f.svg";